<template>
  <div class="home-page">
    <section class="top-section">
      <div class="container-lg">
        <div class="row top-border">
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
        </div>
        <div class="row">
          <div class="col-md-6 hero-cta">
            <h1>
              Make your family tree irresistible.
            </h1>
            <h2>
              It's easy to create a fun, endless learning experience your family will love.
            </h2>
            <div class="actions">
              <div class="primary-actions">
                <router-link class="btn btn-primary" to="/signup" @click="trackClick('home_cta_hero_upload', { section: 'hero', id: 'cta_hero_upload', target: '/signup' })">
                  Upload my tree
                </router-link>
                <router-link class="btn btn-outline-primary" to="/plans" @click="trackClick('home_cta_hero_plans', { section: 'hero', id: 'cta_hero_plans', target: '/plans' })">
                  Choose a plan
                </router-link>
              </div>
              <!-- <div class="secondary-actions">
                <router-link class="btn btn-link" to="/start/family">
                  I don't have a tree yet
                </router-link>
                <router-link class="btn btn-link" to="/start/dev">
                  I'm a developer
                </router-link>
              </div> -->
            </div>
          </div>
          <div class="col-md-6 hero-image">
            <div class="video-crop">
              <video autoplay muted loop playsinline preload="auto">
                <source :src="assetUrl('tc-demo-explore.final.mp4')" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="partners">
      <div class="goldie-may">
        Works with 
        <a href="https://www.goldiemay.com" target="_blank" rel="noopener" @click="trackClick('home_partner_goldie_may', { section: 'partners', id: 'partner_goldie_may', target: 'https://www.goldiemay.com' })">
          <img src="@/assets/logos/GoldieMay_wide.png"/>
        </a>
      </div>
    </section>
    <section class="quotes container-lg">
      <ul class="list-unstyled">
        <li>
          <img src="@/assets/logos/LisaLouiseCooke.jpg"/>
          <blockquote>
            "Tree Crossing highlights my family tree data in ways that are meaningful to family members — fun, simple factoids that bring all this to life for them."
          </blockquote>
          <a href="https://lisalouisecooke.com" target="_blank" rel="noopener" @click="trackClick('home_quote_lisa_louise_cooke', { section: 'quotes', id: 'quote_lisa_louise_cooke', target: 'https://lisalouisecooke.com' })">
            Lisa Louise Cooke, host of the Genealogy Gems podcast since 2007
          </a>
        </li>
        <li>
          <img src="@/assets/logos/DearMyrtle.png"/>
          <blockquote>
            "This is awesome!
            I have grandchildren that are very curious about genealogy, and this is a way to share it in a fun format."
          </blockquote>
          <a href="https://dearmyrtle.com" target="_blank" rel="noopener" @click="trackClick('home_quote_dearmyrtle', { section: 'quotes', id: 'quote_dearmyrtle', target: 'https://dearmyrtle.com' })">
            DearMYRTLE, genealogy forum and webinar host since 1985
          </a>
        </li>
        <li>
          <img src="@/assets/logos/RandySeaver.jpg"/>
          <blockquote>
            "Photos and files were uploaded with my tree. 
            That is the most enticing thing for family members — they love the photos and files."
          </blockquote>
          <a href="https://geneamusings.com" target="_blank" rel="noopener" @click="trackClick('home_quote_randy_seaver', { section: 'quotes', id: 'quote_randy_seaver', target: 'https://geneamusings.com' })">
            Randy Seaver, prolific genealogy blogger since 1992
          </a>
        </li>
        <!-- <li>
          <img src="@/assets/logos/DavidAllenLambert.jpg"/>
          <blockquote>
            "Very excited about Tree Crossing.
            This is a great way to share family history research with relatives and others."
          </blockquote>
          <a href="https://www.americanancestors.org/staff/david-allen-lambert" target="_blank">
            David Lambert, chief genealogist at American Ancestors
          </a>
        </li> -->
      </ul>
    </section>
    <section class="value-section">
      <HomePageValue></HomePageValue>
    </section>
    <section class="youtube-section">
      <div class="container-lg">
        <h1>Learn more from YouTube creators</h1>
        <ul class="list-unstyled youtube-tiles">
          <li>
            <a href="https://www.youtube.com/watch?v=ryCC8osoxlo" target="_blank" rel="noopener" @click="trackClick('home_vid_GenGems_demo', { section: 'youtube', id: 'vid_GenGems_demo', target: 'youtube' })">
              <img src="@/assets/TC_vid_2025_Dec_GenGems_demo.png" alt="A tree your whole family will enjoy"/>
              <span><strong>Interview</strong> with Tree Crossing founders on Genealogy Gems with Lisa Louise Cooke</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/watch?v=NpS7QxJlaGU" target="_blank" rel="noopener" @click="trackClick('home_vid_GenGems', { section: 'youtube', id: 'vid_GenGems', target: 'youtube' })">
              <img src="@/assets/TC_vid_2025_Dec_GenGems.png" alt="Why would I use Tree Crossing?"/>
              <span><strong>Demo</strong> of the Tree Crossing sharing experience on Genealogy Gems</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/live/DYOEyqs-PIc?t=1947" target="_blank" rel="noopener" @click="trackClick('home_vid_Myrt', { section: 'youtube', id: 'vid_Myrt', target: 'youtube' })">
              <img src="@/assets/TC_vid_2025_Sep_Myrte.png" alt="Mondays with Myrt reviews Tree Crossing"/>
              <span>DearMYRTLE and Randy Seaver take Tree Crossing for a spin on Mondays with Myrt</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/watch?v=rJbQa-EVpUE" target="_blank" rel="noopener" @click="trackClick('home_vid_WackyWed', { section: 'youtube', id: 'vid_WackyWed', target: 'youtube' })">
              <img src="@/assets/TC_vid_2025_Sep_Myrte_WackyWed.png" alt="DearMYRTLE's Wacky Wednesday featuring Tree Crossing"/>
              <span>See the "<strong>crossing</strong>" in Tree Crossing with DearMYRTLE's Wacky Wednesday episode</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/watch?v=YRtjvfe7zyo&t=177" target="_blank" rel="noopener" @click="trackClick('home_vid_GoldieMay', { section: 'youtube', id: 'vid_GoldieMay', target: 'youtube' })">
              <img src="@/assets/TC_vid_2026_Mar_GoldieMay.png" alt="Goldie May Integrates with Tree Crossing"/>
              <span>Add <strong>AI research</strong> to your own tree with Goldie May + Tree Crossing</span>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/watch?v=eFNnTUnXmp4" target="_blank" rel="noopener" @click="trackClick('home_vid_GetStarted', { section: 'youtube', id: 'vid_GetStarted', target: 'youtube' })">
              <img src="@/assets/TC_vid_2026_Sep_GetStarted.png" alt="Getting Started with Tree Crossing"/>
              <span>How to <strong>Get Started</strong> with Tree Crossing - Full Walk-through</span>
            </a>
          </li>
        </ul>
      </div>
    </section>
    <section class="action-section">
      <div class="container-lg">
        <div class="decor">
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
          <img src="@/assets/leaf-with-shadow.png"/>
        </div>
        <h1>Share your tree today!</h1>
        <ul class="list-unstyled action-details">
          <li>Uploading your tree is easy, fast, and completely free</li>
          <li>Delete it later if you change your mind</li>
          <li>Share with up to 5 people today, or choose a "practically free" plan to share with more</li>
        </ul>
        <div class="actions">
          <router-link class="btn btn-primary" to="/signup" @click="trackClick('home_cta_bottom_upload', { section: 'bottom-cta', id: 'cta_bottom_upload', target: '/signup' })">
            Upload my tree
          </router-link>
          <router-link class="btn btn-outline-primary" to="/plans" @click="trackClick('home_cta_bottom_plans', { section: 'bottom-cta', id: 'cta_bottom_plans', target: '/plans' })">
            Choose a plan
          </router-link>
        </div>
      </div>
    </section>
    <section class="share-section">
      <h1>Tell your friends!</h1>
      <div class="share-bar">
          <!-- Facebook sharing button -->
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.treecrossing.com" target="_blank" rel="noopener" @click="trackClick('home_share_facebook', { section: 'share', id: 'share_facebook', target: 'facebook' })">
            <img src="@/assets/logos/Facebook.png"/>
          </a>

          <!-- Twitter sharing button -->
          <a href="https://twitter.com/intent/tweet?url=https://www.treecrossing.com&text=The%20best%20way%20to%20share%20your%20family%20trees." target="_blank" rel="noopener" @click="trackClick('home_share_x', { section: 'share', id: 'share_x', target: 'x' })">
            <img src="@/assets/logos/X.png"/>
          </a>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.top-section {
  padding-bottom: 4rem;
  background-color: var(--page-bg-alt);

  .container-lg {
    position: relative;
  }

  .row {
    row-gap: 2rem;
  }

  .row.top-border {
    position: relative;
    margin-top: -5px;
    margin-left: -30px;
    margin-right: -30px;
    height: 60px;

    img {
      position: absolute;
      width: 120px;
    }

    :nth-child(1) {
      top: 80px;
      left: -50px;
      filter: var(--leaf-bright);
      transform: rotate(-50deg);
    }
    :nth-child(2) {
      top: -15px;
      left: -10px;
      filter: var(--leaf-brown);
      transform: rotate(-80deg) var(--leaf-lg);
    }
    :nth-child(3) {
      top: -40px;
      left: 75px;
      filter: var(--leaf-bright);
      transform: rotate(170deg);
    }
    :nth-child(4) {
      top: -15px;
      left: 50px;
      filter: var(--leaf-light);
      transform: rotate(150deg);
    }
    :nth-child(5) {
      top: -60px;
      left: 110px;
      filter: var(--leaf-brown);
      transform: rotate(90deg) var(--leaf-lg);
    }
    :nth-child(6) {
      top: -40px;
      left: 250px;
      filter: var(--leaf-light);
      transform: rotate(-60deg);
    }
    :nth-child(7) {
      top: -10px;
      left: 5px;
      filter: var(--leaf-gray);
      transform: rotate(30deg) var(--leaf-sm);
    }
    :nth-child(n+8) { // 8+
      display: none;
    }

    @media (min-width: 768px) {
      :nth-child(1) {
        left: -40px;
      }
      :nth-child(n+8) { // 8+
        display: block;
      }
      :nth-child(8) {
        top: -40px;
        right: 300px;
        filter: var(--leaf-gray);
        transform: rotate(-10deg);
      }
      :nth-child(9) {
        top: -30px;
        right: 240px;
        filter: var(--leaf-bright);
        transform: rotate(150deg);
      }
      :nth-child(10) {
        top: -55px;
        right: 100px;
        filter: var(--leaf-faded);
        transform: rotate(80deg) var(--leaf-lg);
      }
    }
  }

  .actions {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;

    .primary-actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1rem;

      .btn {
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 0.5rem;
        font-size: 1rem;
        border-radius: 6px;

        @media (min-width: 768px) {
          min-width: 130px;
          height: 50px;
          padding: 0.75rem 1rem;
          font-size: 1.2rem;
        }
      }
    }

    .secondary-actions .btn-link {
      font-size: 0.875rem;

      @media (min-width: 768px) {
        font-size: 1rem;
      }
    }
  }
}

.hero-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2.5rem 2rem;
  z-index: 1;
  text-align: center;

  h1 {
    font-size: 1.8rem;
  }

  h2 {
    margin-top: 0;
    font-size: 1.1rem;
    line-height: 1.4;
    color: #666;

    em {
      font-style: normal;
      font-weight: 400;
      color: #333;
    }
  }

  @media (min-width: 768px) { // above --bs-breakpoint-md
    padding: 2rem 3rem;
    padding-left: 4rem;

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.2rem;
    }
  }

  @media (min-width: 1200px) { // above --bs-breakpoint-xl
    h1 {
      max-width: 400px;
      font-size: 2.5rem;
    }
    h2 {
      font-size: 1.3rem;
    }
  }
}

.hero-image {
  display: flex;
  align-items: center;

  .video-crop {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);  // soft wide shadow for depth
    aspect-ratio: 14 / 9; // a little tighter than 16:9
  }
  
  video {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media (min-width: 768px) {
    .video-crop {
      max-width: 500px;
    }
  }
}

.partners {
  padding: 1rem 0;
  display: flex;
  justify-content: center;

  .goldie-may {
    color: #b29760;

    img {
      width: 128px;
    }
  }
}

.quotes {
  padding: 6rem 0;

  ul {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    flex-basis: 100%;
    column-gap: 6rem;
    row-gap: 4rem;
    justify-content: center;
  }

  li {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 1rem;
    row-gap: 0.5rem;
    max-width: 350px;

    img {
      width: 65px;
      max-height: 75px;
      object-fit: contain;
    }

    blockquote {
      margin: 0;
    }

    a {
      grid-column: 2;
      font-size: 0.875rem;
      color: #888;
    }
  }
}

.youtube-section {
  padding: 6rem 0;

  h1 {
    text-align: center;
    margin-bottom: 3rem;
  }

  // Change --yt-cols to control tiles per row (respects container width regardless)
  .youtube-tiles {
    --yt-cols: 3;
    --yt-gap: 2rem;
    --yt-max-tile: 300px;

    margin: 0;
    display: grid;
    grid-template-columns: repeat(var(--yt-cols), minmax(0, var(--yt-max-tile)));
    justify-content: center;
    gap: var(--yt-gap);

    li a {
      display: flex;
      flex-direction: column;
      gap: 0.6rem;
      text-decoration: none;
      color: inherit;

      &:hover img {
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
        transform: translateY(-2px);
      }

      img {
        width: 100%;
        border-radius: 6px;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
        transition: box-shadow 0.2s ease, transform 0.2s ease;
        aspect-ratio: 16 / 9;
        object-fit: cover;
      }

      span {
        font-size: 0.9rem;
        line-height: 1.4;
        color: #444;
      }
    }

    @media (max-width: 767px) {
      --yt-cols: 1;
    }
  }
}

.action-section {
  padding: 6rem 0;
  background-color: var(--page-bg-alt2);
  font-size: 1.1rem;

  .container-lg {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .decor {
    position: absolute;
    inset: 0;
    pointer-events: none;

    img {
      display: none;

      @media (min-width: 768px) {
        display: block;
        position: absolute;
        width: 80px;

        &:nth-child(1) {
          top: 10%;
          left: 0%;
          filter: var(--leaf-light);
          transform: rotate(70deg) scale(0.9);
        }

        &:nth-child(2) {
          top: 5;
          left: 9%;
          filter: var(--leaf-bright);
          transform: rotate(-10deg) scale(1.2);
        }

        &:nth-child(3) {
          top: 70%;
          left: 5%;
          filter: var(--leaf-brown);
          transform: rotate(50deg) scale(1);
        }

        &:nth-child(4) {
          top: 15%;
          right: 10%;
          filter: var(--leaf-mid);
          transform: rotate(-20deg) scale(1);
        }

        &:nth-child(5) {
          top: 45%;
          right: 5%;
          filter: var(--leaf-gray);
          transform: rotate(60deg) scale(1.2);
        }
      }
    }
  }

  h1 {
    text-align: center;
  }

  .action-details {
    margin: 1.5rem auto 2rem;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0 1rem;
    padding-left: 2.5rem;

    li {
      position: relative;

      &::before {
        position: absolute;
        content: "";
        top: 2px;
        left: -32px;
        width: 24px;
        height: 24px;
        background-image: url("@/assets/icons/check_thin.svg");
        background-repeat: no-repeat;
        background-size: contain;
        filter: invert(1) brightness(0.5) sepia(1) hue-rotate(100deg) saturate(3);
      }
    }    
  }

  .actions {
    align-self: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    justify-content: center;

    .btn {
      font-size: 1rem;
      padding: 0.75rem 0.5rem;

      @media (min-width: 768px) {
        font-size: 1.2rem;
        padding: 0.75rem 1rem;
        border-radius: 6px;
      }
    }
  }
}

.share-section {
  margin: 3rem auto 0;
  max-width: 800px;
  padding: 0 1rem 2rem;

  h1 {
    font-size: 2rem;
    text-align: center;
  }

  .share-bar {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
  }

  .share-bar a {
      margin: 0 10px;
      text-decoration: none;
      color: #212529;

      img {
        width: 30px;
      }
  }

  .share-bar a:hover {
      color: #0d6efd;
  }
}
</style>

<script lang="ts" setup>
import { Environment } from '@/util/Environment'
import { trackClick } from '@/util/Analytics'
import HomePageValue from '@/public/HomePageValue.vue'

function assetUrl(relativePath: string) {
  return `${Environment.get('ASSET_URL')}/${relativePath}`
}
</script>
